import { memo } from 'react';
import FirstCourseModeOption from '../../Organisms/FirstCourseModeOption/FirstCourseModeOption';

const BuyCourseCarouselComponent = ({
  parameters,
  badgeImage,
  courseItem,
  scrollToCourseMembership,
  changeView,
  showEnrrolmentForm,
  setShowEnrrolmentForm,
  handleUpdateMemberships,
  isMobile,
  membershipListIdScheduler,
  language,
  schedulerListCourse
  // downloadableContent
}) => {
  return (
    <div className="container">
      <FirstCourseModeOption
        {...{
          schedulerListCourse,
          courseItem,
          parameters,
          badgeImage,
          scrollToCourseMembership,
          changeView,
          showEnrrolmentForm,
          setShowEnrrolmentForm,
          handleUpdateMemberships,
          isMobile,
          membershipListIdScheduler,
          language
        }}
      />
    </div>
  );
};

export default memo(BuyCourseCarouselComponent);
